import lodash, { isEmpty, size } from 'lodash'
import React, { ReactElement, useEffect } from 'react'
import styled from 'styled-components'

import { useField } from '../../../../../../../1stlog-ui/src/components/Field'
import useFieldState from '../../../../../../../1stlog-ui/src/components/Field/useFieldState'
import TypeSelect from './TypeSelect'

const Wrapper = styled.div``

const TypesSelect = (): ReactElement => {
  const [isEnabled, setIsEnabled] = useFieldState('isEnabled')

  const types = useField('types')

  const [isEmailEnabled, setIsEmailEnabled] = useFieldState('email')

  const isEmail = size(types) === 1 && types[0] === 'email'

  useEffect(() => {
    if (
      isEnabled &&
      size(types) === 1 &&
      types[0] === 'email' &&
      isEmpty(isEmailEnabled)
    ) {
      setTimeout(() => {
        console.log('enable ')
        setIsEmailEnabled(true)
      }, 0)
    }
  }, [isEnabled, types])

  if (!isEnabled) {
    return <></>
  }

  return (
    <div hidden={!!isEmail}>
      <Wrapper className="d-flex">
        {lodash.map(types, (type) => (
          <TypeSelect type={type} />
        ))}
      </Wrapper>
    </div>
  )
}

export default TypesSelect
